export function extractTweetId(url: string): string | undefined {
  const urlArray = url.split(/\/status\/|\/statuses\//)
  const tweetId = urlArray[1] && urlArray[1].split('/')[0]
  return tweetId
}
